import { ModalProps } from "react-bootstrap";
import PrivacyPolicyContent from "../data/privacyPolicyContent";
import LegalDocumentModal from "./LegalDocumentModal";

interface PrivacyPolicyModalProps extends ModalProps {
  show: boolean;
  onHide: () => void;
}

const PrivacyPolicyModal = ({ show, onHide, ...props }: PrivacyPolicyModalProps) => (
  <LegalDocumentModal
    {...props}
    show={show}
    onHide={onHide}
    title="Privacy Policy"
  >
    <PrivacyPolicyContent />
  </LegalDocumentModal>
);

export default PrivacyPolicyModal;
